import { ModifyEventSchema } from '../../../../events/Events.schema'

type Option = ModifyEventSchema['options'][number]
export const defaultOption = (): Option => ({
  id: -1,
  name: '',
  type: '' as unknown as Option['type'],
  sub_event: null,
  session: null,
  registration_information: '',
  deadline: null,
  max_participants: null,
  _new: true,
})
